// elementUi 组件按需加载
import Vue from 'vue'
import {
	Button,
	Table,
	TableColumn,
	Form,
	FormItem,
	Input,
	Select,
	Option,
	DatePicker,
	Dialog,
	Message,
	Badge,
	Menu,
	MenuItem,
	MenuItemGroup,
	Submenu,
	Checkbox,
	CheckboxButton,
	CheckboxGroup,
	Pagination,
	Carousel,
	CarouselItem,
	Tabs,
	TabPane,
	Radio,
	RadioGroup,
	RadioButton,
	Tooltip,
	Row,
	Col,
	Tag,
	Upload,
	Loading,
	Image,
	Switch,
	TimeSelect,
	TimePicker,
	Cascader,
	InputNumber,
	Divider,
	Popover
} from 'element-ui'

// 注册组件
const components = [
	Button,
	Table,
	TableColumn,
	Form,
	FormItem,
	Input,
	Select,
	Option,
	DatePicker,
	Dialog,
	Badge,
	Menu,
	MenuItem,
	MenuItemGroup,
	Submenu,
	Checkbox,
	CheckboxButton,
	CheckboxGroup,
	Pagination,
	Carousel,
	CarouselItem,
	Tabs,
	TabPane,
	Radio,
	RadioGroup,
	RadioButton,
	Tooltip,
	Row,
	Col,
	Tag,
	Upload,
	Image,
	Switch,
	TimeSelect,
	TimePicker,
	Cascader,
	InputNumber,
	Divider,
	Popover
]

components.forEach(component => {
	Vue.use(component)
})

// 对于某些组件，需要挂载到 Vue.prototype 上
Vue.prototype.$message = Message

// 使用Loading指令
Vue.use(Loading.directive)
// 如果需要使用服务方式的Loading，可以添加下面这行
// Vue.prototype.$loading = Loading.service
